import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { UserRoles } from '../../../project/Defines';
import InputCont from '../../../Shared/Form/InputCont';

export default function Remark(props) {
    const { dataItem, disabled, onChangeData } = props;
    const role = useSelector(s => s.role);

    let diagnosis = dataItem?.diagnosis;

    if (diagnosis) {
        diagnosis = diagnosis.split('_').map(part => part.trim()).slice(0, 3).join('\n');
    }

    return (
        <view light="" scroll_wrapper="">
            <div className='section_group'>
                <div className='sections wide'>
                    <form>

                        <InputCont
                            label='text.description_ga'
                            inputProps={{
                                disabled: disabled || role === UserRoles.USER,
                                name: 'description',
                                type: 'textarea',
                                value: dataItem.description,
                                placeholder: "",
                                onChange: onChangeData
                            }}
                        />
                        <InputCont
                            label='text.description_sat'
                            inputProps={{
                                disabled: disabled || role === UserRoles.CALL_CENTER || dataItem.is_cancelled_status,
                                name: 'description_sat',
                                type: 'textarea',
                                value: dataItem.description_sat,
                                placeholder: "",
                                onChange: onChangeData
                            }}
                        />
                        <InputCont
                            label='text.diagnosis'
                            inputProps={{
                                name: 'diagnosis',
                                type: 'textarea',
                                disabled: true,
                                value: diagnosis,
                                // onChange: e => onCodeChanged('diagnosis', e),
                            }}
                        />
                        {/* <div className='sections wide' data-adaptive="mobile">
                            <action right=""
                            >
                                <div
                                    //onClick={(e) => updateData(updateSuccessCallback)}
                                    className='button primary'
                                //disabled={!isNotValidated && dataItem.status_id == "2"}
                                ><icon>save</icon>text.save</div>
                            </action>
                        </div>
                        <div className='sections' data-adaptive="mobile"></div>
                        <div className='sections' data-adaptive="mobile"></div>
                        <div className='sections' data-adaptive="mobile"></div>
                        <div className='sections' data-adaptive="mobile"></div> */}
                    </form>
                </div>
            </div>
        </view>
    );
}

Remark.propTypes = {
    dataItem: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    onChangeData: PropTypes.func.isRequired
};
